import { render, staticRenderFns } from "./CreateAcountModalForm.vue?vue&type=template&id=66a32358&scoped=true"
import script from "./CreateAcountModalForm.vue?vue&type=script&lang=ts"
export * from "./CreateAcountModalForm.vue?vue&type=script&lang=ts"
import style0 from "./CreateAcountModalForm.vue?vue&type=style&index=0&id=66a32358&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a32358",
  null
  
)

export default component.exports